<template>
  <div class="mains">
    <div class="campus">功能模块 <span>></span> <a @click="back">趣配音</a> <span>></span> 上传视频</div>
    <el-card shadow="never" class="pane">
      <div slot="header" class="card-title">上传视频 · {{ chapterTitle || '章节' }}</div>
      <el-alert class="warn" type="warning" :closable="false" center>
        <span
          slot="title">“趣配音”模块所上传的最终结果会根据您所排列的顺序及节点切分展现在小程序的趣配音功能部分。</span>
      </el-alert>
      <el-form label-width="100px" size="small" class="chapter-form" @submit.native.prevent>
        <el-form-item label="名称" required>
          <el-input
            ref="nameInput"
            v-model="chapterTitle"
            :disabled="nameLocked"
            placeholder="请输入章节名称"
            @blur="saveName"
            @keyup.enter.native="blurTarget"
          />
          <div class="under">
            <el-button type="primary" size="small" :loading="nameSaving" @click="unlockName">重命名</el-button>
          </div>
        </el-form-item>
        <el-form-item label="序号" required>
          <el-input
            ref="seqInput"
            v-model="chapterSeq"
            :disabled="seqLocked"
            placeholder="请输入序号"
            @blur="saveSeq"
            @keyup.enter.native="blurTarget"
          />
          <div class="under">
            <el-button type="primary" size="small" :loading="seqSaving" @click="unlockSeq">重置</el-button>
          </div>
        </el-form-item>
        <el-form-item label="封面">
          <img v-if="chapterCover" :src="chapterCover" class="chapter-cover" alt=""/>
          <div v-else class="hint">未上传封面时使用系统默认图片。</div>
          <div class="under">
            <el-upload action="#" :show-file-list="false" accept="image/*" :http-request="uploadChapterCover"
                       :disabled="coverSaving">
              <el-button type="primary" size="small" :loading="coverSaving">更换封面</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div class="list-bar">
        <span>视频列表</span>
        <el-button type="primary" size="small" :disabled="!!listActing" @click="openCreate">新增</el-button>
      </div>
      <el-table :data="rows" border size="mini" :header-cell-style="headerStyle" empty-text="暂无数据">
        <el-table-column label="视频名称" align="center" min-width="220" prop="title" show-overflow-tooltip/>
        <el-table-column label="视频排序" align="center" width="96" prop="seqnum"/>
        <el-table-column label="配音状态" align="center" min-width="168">
          <template slot-scope="scope">
            <span class="cell-text">
              {{ scope.row.statusLabel || '未配置' }}
              <template v-if="scope.row.pendingEdit"> · 有未上架修改</template>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="句数 / 时长" align="center" min-width="168">
          <template slot-scope="scope">
            <span class="cell-text">{{ scope.row.lineCount || 0 }} 句 / {{ seconds(scope.row.durationMs) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="280">
          <template slot-scope="scope">
            <div class="ops">
              <el-button type="text" size="mini" :loading="isActing(scope.row, 'edit')"
                         :disabled="!!listActing && !isActing(scope.row, 'edit')" @click="openEdit(scope.row)">编辑
              </el-button>
              <el-button type="text" size="mini" :loading="isActing(scope.row, 'dub')"
                         :disabled="!!listActing && !isActing(scope.row, 'dub')" @click="editDubbing(scope.row)">编辑配音
              </el-button>
              <el-button v-if="scope.row.status === 'PUBLISHED'" type="text" size="mini"
                         :loading="isActing(scope.row, 'offline')"
                         :disabled="!!listActing && !isActing(scope.row, 'offline')" @click="offline(scope.row)">下架
              </el-button>
              <el-button type="text" size="mini" class="link-danger" :loading="isActing(scope.row, 'remove')"
                         :disabled="!!listActing && !isActing(scope.row, 'remove')" @click="remove(scope.row)">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-button size="small" :disabled="pageBusy" @click="back">返回</el-button>
      </div>
    </el-card>

    <el-dialog :title="form.watchId ? '编辑视频' : '新增视频'" :visible.sync="dialogOpen" width="560px"
               :close-on-click-modal="false" :before-close="closeDialog" @closed="resetForm">
      <el-form ref="videoForm" :model="form" :rules="rules" label-width="120px" size="small" class="video-form">
        <el-form-item label="视频名称" prop="title">
          <el-input v-model="form.title" maxlength="50" placeholder="请输入视频名称"/>
        </el-form-item>
        <el-form-item label="视频排序" prop="seqnum">
          <el-input-number v-model="form.seqnum" :min="0" :max="9999"/>
        </el-form-item>
        <el-form-item label="视频文件" prop="fileName">
          <div class="pick">
            <el-upload action="#" accept=".mp4,video/mp4" :show-file-list="false" :auto-upload="false"
                       :on-change="onVideoPicked">
              <el-button size="small" type="primary">选择视频</el-button>
            </el-upload>
            <span class="hint">{{ form.fileName || (form.watchId ? '不选则保留原视频' : '请选择 mp4 文件') }}</span>
          </div>
        </el-form-item>
        <el-form-item label="封面">
          <div class="pick">
            <el-upload action="#" accept="image/*" :show-file-list="false" :auto-upload="false"
                       :on-change="onCoverPicked">
              <el-button size="small">选择封面</el-button>
            </el-upload>
            <span class="hint">{{ form.coverName || '选填，不选则不改封面' }}</span>
          </div>
          <img v-if="form.coverUrl" :src="form.coverUrl" class="cover" alt=""/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" :disabled="saving" @click="dialogOpen = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/** 章节共用视频。视频的新增和编辑都在弹窗里完成，列表只展示。 */
function blankForm(seqnum) {
  return {watchId: null, title: '', seqnum, file: null, fileName: '', coverFile: null, coverName: '', coverUrl: ''};
}

export default {
  name: 'dubbingVideos',
  data() {
    const requireTitle = (rule, value, callback) => {
      if (!(value || '').trim()) callback(new Error('请输入视频名称'));
      else callback();
    };
    const requireSeq = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined || !Number.isFinite(Number(value))) callback(new Error('请输入视频排序'));
      else callback();
    };
    const requireFile = (rule, value, callback) => {
      if (!this.form.watchId && !this.form.file) callback(new Error('请选择视频文件'));
      else callback();
    };
    return {
      rows: [],
      bookId: '',
      chapterId: '',
      chapterTitle: '',
      chapterSeq: '',
      chapterCover: '',
      coverSaving: false,
      nameSaving: false,
      seqSaving: false,
      /** 列表上正在进行的一行操作，格式 watchId:edit|dub|offline|remove。 */
      listActing: '',
      page: 1,
      keyword: '',
      nameLocked: true,
      seqLocked: true,
      dialogOpen: false,
      saving: false,
      form: blankForm(1),
      rules: {
        title: [{validator: requireTitle, trigger: 'blur'}],
        seqnum: [{validator: requireSeq, trigger: 'change'}],
        fileName: [{validator: requireFile, trigger: 'change'}],
      },
    };
  },
  computed: {
    /** 章节保存或列表操作未结束时，先别离开这一页。 */
    pageBusy() {
      return !!(this.listActing || this.nameSaving || this.seqSaving || this.coverSaving || this.saving);
    },
  },
  created() {
    this.bookId = this.$route.query.bookId;
    this.chapterId = this.$route.query.chapterId;
    this.chapterTitle = this.$route.query.title || '';
    this.chapterSeq = this.$route.query.seqnum != null ? String(this.$route.query.seqnum) : '0';
    this.chapterCover = this.$route.query.cover || '';
    this.page = this.$route.query.page || 1;
    this.keyword = this.$route.query.keyword || '';
    this.load();
    this.loadChapter();
  },
  methods: {
    auth() {
      return {Authorization: 'Bearer ' + window.sessionStorage.getItem('userinfo').replace(/"/g, '')};
    },
    headerStyle() {
      return {background: '#F2F2F2', color: '#333', fontWeight: '600'};
    },
    seconds(ms) {
      return ms ? (ms / 1000).toFixed(1) + ' 秒' : '—';
    },
    blurTarget(event) {
      event.target.blur();
    },
    isActing(row, act) {
      return this.listActing === row.watchId + ':' + act;
    },
    /** 点下去立刻占住这一行，请求结束才放开。 */
    beginRow(row, act) {
      if (this.listActing) return false;
      this.listActing = row.watchId + ':' + act;
      return true;
    },
    endRow(row, act) {
      const key = row.watchId + ':' + act;
      if (this.listActing === key) this.listActing = '';
    },
    /** 进入页面时拉一次章节。封面用接口返回的 picurl，没上传时接口会带系统默认图。 */
    loadChapter() {
      if (!this.chapterId) return;
      this.$http({
        url: '/edu/chapterandsection/selctChapterandsectionById/' + this.chapterId,
        method: 'GET',
        headers: this.auth(),
      }).then((res) => {
        if (res.data.code !== 0 || !res.data.data) return;
        const data = res.data.data;
        if (data.title) this.chapterTitle = data.title;
        if (data.seqnum != null) this.chapterSeq = String(data.seqnum);
        this.chapterCover = data.picurl || '';
      });
    },
    load() {
      return this.$http({
        url: '/edu/dubbing/videos',
        method: 'GET',
        headers: this.auth(),
        params: {bookId: this.bookId, chapterId: this.chapterId}
      })
        .then((res) => {
          if (res.data.code !== 0) return this.$message.error(res.data.message);
          this.rows = res.data.data || [];
        });
    },
    back() {
      if (this.pageBusy) return;
      this.$router.push({name: 'dubbing', query: {bookId: this.bookId, page: this.page, keyword: this.keyword}});
    },
    /** 名称和序号一起提交，避免只改一边把另一边写成空。 */
    saveChapter(okText, extra) {
      const seq = Number(this.chapterSeq);
      const data = {id: Number(this.chapterId), bookid: Number(this.bookId), title: this.chapterTitle, seqnum: seq};
      if (extra && extra.picurl) data.picurl = extra.picurl;
      return this.$http({
        url: '/edu/chapterandsection/updateChapter', method: 'POST', headers: this.auth(), data,
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.message);
          return false;
        }
        this.$message.success(okText || '章节已保存');
        return true;
      });
    },
    unlockName() {
      if (this.nameSaving) return;
      this.nameLocked = false;
      this.$nextTick(() => {
        if (this.$refs.nameInput) this.$refs.nameInput.focus();
      });
    },
    saveName() {
      if (this.nameLocked || this.nameSaving) return;
      const title = (this.chapterTitle || '').trim();
      if (!title) return this.$message.warning('请输入章节名称');
      this.chapterTitle = title;
      this.nameSaving = true;
      this.saveChapter('章节重命名成功').then((ok) => {
        if (ok) this.nameLocked = true;
      })
        .then(() => {
          this.nameSaving = false;
        }, () => {
          this.nameSaving = false;
        });
    },
    unlockSeq() {
      if (this.seqSaving) return;
      this.seqLocked = false;
      this.$nextTick(() => {
        if (this.$refs.seqInput) this.$refs.seqInput.focus();
      });
    },
    uploadChapterCover(req) {
      if (this.coverSaving) return;
      this.coverSaving = true;
      const body = new FormData();
      body.append('file', req.file);
      body.append('orgid', window.sessionStorage.getItem('orgid'));
      this.$http({url: '/mini/miniInfo/uploadimage', method: 'POST', data: body, headers: this.auth()}).then((res) => {
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        return this.saveChapter('封面已更新', {picurl: res.data.data}).then((ok) => {
          if (ok) this.chapterCover = res.data.data;
        });
      }).catch(() => {
        this.$message.error('封面上传失败');
      }).then(() => {
        this.coverSaving = false;
      });
    },
    saveSeq() {
      if (this.seqLocked || this.seqSaving) return;
      const seq = Number(this.chapterSeq);
      if (!Number.isFinite(seq) || seq < 0) return this.$message.warning('序号请填写不小于 0 的数字');
      this.chapterSeq = String(seq);
      this.seqSaving = true;
      this.saveChapter('序号已保存').then((ok) => {
        if (ok) this.seqLocked = true;
      })
        .then(() => {
          this.seqSaving = false;
        }, () => {
          this.seqSaving = false;
        });
    },
    openCreate() {
      if (this.listActing) return;
      this.form = blankForm(this.rows.length + 1);
      this.dialogOpen = true;
      this.$nextTick(() => {
        if (this.$refs.videoForm) this.$refs.videoForm.clearValidate();
      });
    },
    openEdit(row) {
      if (!this.beginRow(row, 'edit')) return;
      this.form = {
        watchId: row.watchId,
        title: row.title,
        seqnum: Number(row.seqnum) || 0,
        file: null,
        fileName: '',
        coverFile: null,
        coverName: '',
        coverUrl: row.coverUrl || '',
      };
      this.dialogOpen = true;
      this.$nextTick(() => {
        if (this.$refs.videoForm) this.$refs.videoForm.clearValidate();
      });
      this.$http({
        url: '/edu/watch/selectCover?watchId=' + row.watchId,
        method: 'GET',
        headers: this.auth()
      }).then((res) => {
        if (res.data.code === 0 && this.form.watchId === row.watchId && !this.form.coverFile) this.form.coverUrl = res.data.data || '';
      }).then(() => {
        this.endRow(row, 'edit');
      }, () => {
        this.endRow(row, 'edit');
      });
    },
    closeDialog(done) {
      if (this.saving) return;
      done();
    },
    resetForm() {
      this.form = blankForm(this.rows.length + 1);
    },
    onVideoPicked(file) {
      const raw = file.raw;
      if (!raw || !/\.mp4$/i.test(raw.name)) return this.$message.warning('请选择 mp4 视频');
      this.form.file = raw;
      this.form.fileName = raw.name;
      this.$refs.videoForm.validateField('fileName');
    },
    onCoverPicked(file) {
      const raw = file.raw;
      if (!raw) return;
      this.form.coverFile = raw;
      this.form.coverName = raw.name;
      this.form.coverUrl = URL.createObjectURL(raw);
    },
    submit() {
      if (this.saving) return;
      this.saving = true;
      this.$refs.videoForm.validate((ok) => {
        if (!ok) {
          this.saving = false;
          return;
        }
        const job = this.form.watchId ? this.saveEdit() : this.saveCreate();
        job.then((done) => {
          if (!done) return;
          this.dialogOpen = false;
          return this.load().then(() => {
          }, () => {
          });
        }).catch(() => {
          this.$message.error('保存失败');
        }).then(() => {
          this.saving = false;
        });
      });
    },
    /** 上传视频文件，成功返回地址。 */
    uploadVideoFile(file) {
      const body = new FormData();
      body.append('video', file);
      return this.$http({
        url: '/edu/uploadOss/uploadVideo',
        method: 'POST',
        data: body,
        headers: this.auth()
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.message);
          return null;
        }
        return res.data.data;
      });
    },
    uploadCoverFile(file) {
      const body = new FormData();
      body.append('file', file);
      body.append('orgid', window.sessionStorage.getItem('orgid'));
      return this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: body,
        headers: this.auth()
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.message);
          return null;
        }
        return res.data.data;
      });
    },
    saveCover(watchId, coverUrl) {
      return this.$http({
        url: '/edu/watch/editCover', method: 'POST', headers: this.auth(),
        data: {videoId: watchId, coverUrl},
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.message);
          return false;
        }
        return true;
      });
    },
    /** 新增接口有的只回成功，不带回 id。能拿到 id 才接着保存封面。 */
    watchIdOf(data) {
      if (data == null || data === '') return null;
      if (typeof data === 'number' || typeof data === 'string') return data;
      return data.id || data.watchId || null;
    },
    saveCreate() {
      return this.uploadVideoFile(this.form.file).then((url) => {
        if (!url) return false;
        return this.$http({
          url: '/edu/watch/addWatch', method: 'POST', headers: this.auth(),
          data: {
            title: this.form.title.trim(),
            video_url: url,
            orgid: window.sessionStorage.getItem('orgid'),
            bookid: this.bookId,
            chapterid: this.chapterId,
            seqnum: this.form.seqnum,
          },
        });
      }).then((res) => {
        if (!res || res.data.code !== 0) {
          if (res) this.$message.error(res.data.message);
          return false;
        }
        const watchId = this.watchIdOf(res.data.data);
        if (!this.form.coverFile || !watchId) {
          this.$message.success('视频已新增');
          return true;
        }
        return this.uploadCoverFile(this.form.coverFile).then((coverUrl) => {
          if (!coverUrl) return true;
          return this.saveCover(watchId, coverUrl);
        }).then(() => {
          this.$message.success('视频已新增');
          return true;
        });
      });
    },
    saveEdit() {
      const payload = {id: this.form.watchId, title: this.form.title.trim(), seqnum: Number(this.form.seqnum)};
      const uploaded = this.form.file ? this.uploadVideoFile(this.form.file) : Promise.resolve('');
      return uploaded.then((url) => {
        if (this.form.file && !url) return null;
        if (url) payload.video_url = url;
        return this.$http({url: '/edu/watch/updateWatch', method: 'POST', headers: this.auth(), data: payload});
      }).then((res) => {
        if (!res || res.data.code !== 0) {
          if (res) this.$message.error(res.data.message);
          return false;
        }
        if (!this.form.coverFile) {
          this.$message.success('视频已保存');
          return true;
        }
        return this.uploadCoverFile(this.form.coverFile).then((coverUrl) => {
          if (!coverUrl) return true;
          return this.saveCover(this.form.watchId, coverUrl);
        }).then(() => {
          this.$message.success('视频已保存');
          return true;
        });
      });
    },
    editDubbing(row) {
      if (!this.beginRow(row, 'dub')) return;
      this.$http({
        url: '/edu/dubbing/materials', method: 'POST', headers: this.auth(),
        data: {bookId: Number(this.bookId), chapterId: Number(this.chapterId), watchId: row.watchId, title: row.title},
      }).then((res) => {
        if (res.data.code !== 0) {
          this.endRow(row, 'dub');
          return this.$message.error(res.data.message);
        }
        this.$router.push({
          name: 'dubbingAxis',
          query: {
            materialId: res.data.data.materialId,
            bookId: this.bookId,
            chapterId: this.chapterId,
            title: this.chapterTitle,
            seqnum: this.chapterSeq
          }
        })
          .catch(() => {
            this.endRow(row, 'dub');
          });
      }).catch(() => {
        this.endRow(row, 'dub');
      });
    },
    offline(row) {
      if (!this.beginRow(row, 'offline')) return;
      const clear = () => {
        this.endRow(row, 'offline');
      };
      this.$confirm('下架后学生不能再配这条素材。已经生成的作品仍可播放和分享。', '下架').then(() => {
        return this.$http({
          url: '/edu/dubbing/materials/' + row.materialId + '/offline',
          method: 'POST',
          headers: this.auth()
        })
          .then((res) => {
            if (res.data.code !== 0) return this.$message.error(res.data.message);
            return this.load();
          });
      }).catch(() => {
      }).then(clear, clear);
    },
    remove(row) {
      if (!this.beginRow(row, 'remove')) return;
      const clear = () => {
        this.endRow(row, 'remove');
      };
      this.$http({
        url: '/edu/dubbing/watches/' + row.watchId + '/references',
        method: 'GET',
        headers: this.auth()
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.message);
          return;
        }
        if (res.data.data.count > 0) {
          this.$message.error('这条视频已经有配音配置。请先下架，不要把它当成删除学生作品。');
          return;
        }
        return this.$confirm('删除后微剧场里的同一条视频也会消失。', '删除视频').then(() => {
          return this.$http({url: '/edu/watch/deleteWatch?watchId=' + row.watchId, method: 'GET', headers: this.auth()})
            .then((done) => {
              if (done.data.code !== 0) return this.$message.error(done.data.message);
              return this.load();
            });
        }).catch(() => {
        });
      }).then(clear, clear);
    },
  },
};
</script>

<style scoped>
.pane {
  border: 1px solid #ededed;
  border-radius: 2px;
}

.pane /deep/ .el-card__header {
  padding: 0;
  border-bottom: none;
}

.pane /deep/ .el-card__body {
  padding: 15px;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 15px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.card-title::before {
  content: '';
  width: 2px;
  height: 13px;
  background: #1e9fff;
}

.warn {
  margin-bottom: 18px;
  background: #fdf6ec;
}

.warn /deep/ .el-alert__title {
  font-size: 13px;
  font-weight: 400;
  color: #e6a23c;
}

.chapter-form /deep/ .el-form-item {
  margin-bottom: 20px;
}

.chapter-form /deep/ .el-form-item__label {
  color: #333;
}

.chapter-form /deep/ .el-input.is-disabled .el-input__inner {
  background: #fff;
  color: #666;
  border-color: #e6e6e6;
  cursor: default;
}

.under {
  margin-top: 8px;
}

.chapter-cover {
  width: 120px;
  height: 86px;
  object-fit: contain;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  background: #fff;
  display: block;
}

.list-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0 12px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.footer {
  margin-top: 18px;
}

.cell-text {
  white-space: nowrap;
}

.ops {
  white-space: nowrap;
}

.ops /deep/ .el-button {
  margin: 0 6px;
  padding: 0;
}

.video-form /deep/ .el-form-item__label {
  white-space: nowrap;
  color: #333;
}

.pick {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hint {
  color: #999;
  font-size: 12px;
}

.cover {
  display: block;
  width: 160px;
  height: 90px;
  object-fit: cover;
  margin-top: 8px;
  border: 1px solid #e6e6e6;
}

.link-danger {
  color: #f56c6c;
}

.pane /deep/ .el-table th {
  background: #f2f2f2;
  color: #333;
}

.pane /deep/ .el-table td,
.pane /deep/ .el-table th {
  border-color: #e6e6e6;
}

a {
  cursor: pointer;
  color: #666;
}
</style>
